module.exports = __webpack_public_path__ + "img/welcome-page-img3.2a691046.svg";